import BusStopData from '../../schema/viewSchema/BusStopData';
import EventReservation from '../../schema/EventReservation';
import TxpStrings from '../../schema/configSchema/TxpStrings';

/**
 * Extracts the event reservation specific data needed for displaying the bus stop
 */
export default function populateEventBusStopData(
    eventEntity: EventReservation,
    startTime: string,
    ariaStartTime: string,
    txpStrings: TxpStrings,
    icon: string
): BusStopData {
    let collapsedText: string;
    let ariaBusStopText: string;
    let city: string = eventEntity.location ? eventEntity.location.city : null;

    if (city) {
        collapsedText = txpStrings.formatters.format(
            txpStrings.strings.cityDateFormatText,
            city,
            startTime
        );
        ariaBusStopText = txpStrings.formatters.format(
            txpStrings.strings.cardWithCitySummaryAriaText,
            eventEntity.eventName,
            city,
            ariaStartTime
        );
    } else {
        collapsedText = startTime;
        ariaBusStopText = txpStrings.formatters.format(
            txpStrings.strings.cardSummaryAriaText,
            eventEntity.eventName,
            ariaStartTime
        );
    }

    return {
        busStopLabel: txpStrings.strings.reservationLabelText,
        busStopText: eventEntity.eventName,
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
        icon: icon,
    } as BusStopData;
}
